
import React from 'react';
import { FeedbackContent } from './FeedbackContent';
import { Feedback } from './useFeedbackData';
import { NavigateFunction } from 'react-router-dom';

type CandidateFeedbackViewProps = {
  feedback: Feedback;
  formatDate: (date: string) => string;
  navigate: NavigateFunction;
};

export const CandidateFeedbackView = ({ feedback, formatDate, navigate }: CandidateFeedbackViewProps) => {
  return (
    <div className="container max-w-3xl mx-auto px-4 py-8">
      <FeedbackContent 
        feedback={feedback}
        formatDate={formatDate}
        navigate={navigate}
      />
    </div>
  );
};
